import React from 'react';
import { IoIosArrowUp } from "react-icons/io";
import { IoIosArrowDown } from "react-icons/io";

const ToggleArrow = ({isOpen, onToggle}) => {
    return (
        <div onClick={onToggle} className=' cursor-pointer hoverGreen'>
            {isOpen ? 
            <IoIosArrowDown className=' text-xl' /> :
            <IoIosArrowUp className=' text-xl' />
            }
        </div>
    );
}

export default ToggleArrow;
